import {
  AppBar,
  Toolbar,
  Box,
  Button,
  useTheme,
  useMediaQuery,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { navbarContent, NavbarLink } from "../data/siteContent";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { logo, links } = navbarContent;
  const navigate = useNavigate();
  const NAVBAR_HEIGHT = 83;

  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  const handleNavItemClick = (id: NavbarLink, to: string) => {
    navigate(to);
    window.scrollTo(0, 0);
  };

  const menuLinks = links.filter((link) => link.id !== NavbarLink.Home);

  return (
    <AppBar
      position="fixed"
      color="success"
      elevation={0}
      sx={{ padding: 0.5 }}
    >
      <Toolbar
        sx={{ minHeight: NAVBAR_HEIGHT, justifyContent: "space-between" }}
      >
        {/* Logo */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            cursor: "pointer",
          }}
          onClick={() => {
            handleNavItemClick(NavbarLink.Home, "/");
            setDrawerOpen(false);
          }}
        >
          <Box
            component="img"
            src={logo.src}
            alt={logo.alt}
            sx={{ height: 65 }}
          />
        </Box>

        {/* Menú en Escritorio */}
        {!isMobile && (
          <Box sx={{ display: "flex", gap: 2 }}>
            {links.map(({ label, to, isCTA, id }) => (
              <Button
                key={label}
                onClick={() => handleNavItemClick(id, to)}
                variant={isCTA ? "contained" : "text"}
                color={isCTA ? "primary" : "inherit"}
              >
                {label}
              </Button>
            ))}
          </Box>
        )}

        {/* Botón de Menú en Móvil */}
        {isMobile && (
          <>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(!drawerOpen)}
            >
              {drawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>

            {drawerOpen && (
              <Box
                sx={{
                  position: "fixed",
                  top: NAVBAR_HEIGHT,
                  left: 0,
                  width: "100vw",
                  height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
                  backgroundColor: theme.palette.background.paper,
                  color: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "stretch",
                  zIndex: theme.zIndex.drawer,
                  pt: 2,
                }}
              >
                <List>
                  {menuLinks.map(({ label, to, id }) => (
                    <ListItem key={label} disablePadding>
                      <ListItemButton
                        onClick={() => {
                          handleNavItemClick(id, to);
                          setDrawerOpen(false);
                        }}
                      >
                        <ListItemText
                          primary={label}
                          sx={{
                            ml: 2,
                            "& .MuiTypography-root": {
                              fontSize: "1.20rem",
                              fontWeight: 400,
                            },
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
